import React from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'

const range_thumb = styling => css`
    /* margin-top: -${(styling.cursor.size + styling.cursor.borderWidth - (styling.track.height + styling.track.borderWidth)) / 2}px;
    box-sizing: border-box; */
    transition: all 0.5s;

    border: ${styling.cursor.borderWidth}px solid ${styling.cursor.borderColor};
    height: ${styling.cursor.size}px;
    width: ${styling.cursor.size}px;
    border-radius: 100px;
    background: ${styling.cursor.backgroundColor};
`;
const range_bar = styling => css`
    width: 100%;
    height: ${styling.track.height}px;
    background: ${styling.track.color};
    border-radius: ${styling.track.borderRadius};
    border: ${styling.track.borderWidth}px solid ${styling.track.borderColor};
    border-left: 0 !important;
    border-right: 0 !important;
    transition: all 0.5s;
`;
const range_bar_border = styling => css`
    border: ${styling.track.borderWidth}px solid ${styling.track.borderColor};
    border-left: 0 !important;
    border-right: 0 !important;
    transition: all 0.5s;
`;

class CustomRangeInput extends React.Component {
  setValue(val) {
    this.range.value = val;
  }
  render() {
    const {
      min,
      max,
      defaultValue,
      backgroundColor,
      color,
      styling,
      onChange,
      value,
      className,
    } = this.props;
    return (
      <CustomRange
        type="range"
        id="size"
        min={min}
        max={max}
        value={value}
        defaultValue={defaultValue}
        backgroundColor={backgroundColor}
        styling={styling}
        color={color}
        css={className}
                /*removed innerRef*/ ref={el => {
          this.range = el;
        }}
        onChange={el => {
          onChange(el.target.value);
        }}
      />
    );
  }
}

const CustomRange = styled.input`


  -webkit-appearance: none;
  height: ${props => props.styling.track.height || '30px'};
  width: ${props => props.styling.track.width || '100%'};
  min-width: 130px;
  /* margin: 13px 0; */
  background: none;

  &:focus {
    outline: none;
  }
  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 0;
    background: #000000;
    border-radius: 0px;
    ${props => range_bar_border(props.styling)};
  }
  &::-webkit-slider-thumb {
    ${props => range_thumb(props.styling)};
    -webkit-appearance: none;
    margin-top: ${props => `-${parseInt(props.styling.cursor.size) / 2}px` || '-13px'};
  }
  &:focus::-webkit-slider-runnable-track {
    background: #0d0d0d;
  }
  &::-moz-range-track {
    width: 100%;
    height: 1px;
    background: #000000;
    border-radius: 0px;
    ${props => range_bar_border(props.styling)};
  }
  &::-moz-range-thumb {
    ${props => range_thumb(props.styling)};
  }
  &::-ms-track {
    width: 100%;
    height: 1px;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  &::-ms-fill-lower {
    background: #000000;
    border: 0px solid #010101;
    border-radius: 0px;
    ${props => range_bar_border(props.styling)};
    /* box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0); */
  }
  &::-ms-fill-upper {
    background: #000000;
    border: 0px solid #010101;
    border-radius: 0px;
    ${props => range_bar_border(props.styling)};
    /* box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0); */
  }
  &::-ms-thumb {
    ${props => range_thumb(props.styling)};
    margin-top: 0px;
  }
  &:focus::-ms-fill-lower {
    background: #000000;
  }
  &:focus::-ms-fill-upper {
    background: #0d0d0d;
  }



`;
export default CustomRangeInput;


/*
    -webkit-appearance: none;
    -moz-appearance: none;

    background: transparent;
    padding: 0;
    box-sizing: border-box;
    color: inherit;


    &:focus {
        outline: none;
    }

    &::-moz-focus-outer {
        border: 0;
    }

    &::-webkit-slider-runnable-track {
        ${props => range_bar(props.styling)};
    }
    &::-moz-range-track {
        ${props => range_bar(props.styling)};
    }
    &::-ms-track {
        ${props => range_bar(props.styling)};
    }



    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        ${props => range_thumb(props.styling)};
    }
    &::-moz-range-thumb {
        ${props => range_thumb(props.styling)};
    }
    &::-ms-thumb {
        ${props => range_thumb(props.styling)};
        margin-top: 0px;
    }

    &:focus::-ms-thumb {
    }


    &::-ms-tooltip {
        display: none;
    }

    */
